import React, { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import InputFeild from "src/Components/InputFeild";
import CircleButton from "src/Components/GlobalComponents/CircleButton";
import { toast } from "react-toastify";
import httpRequest from "src/helpers/httpRequest";
import { validateEmail } from "src/helpers/helperFunctions";
import { errMsg } from "src/lib/constans";
import moment from "moment";

const DoctorForgetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState("");

  const handleChange = (val: string) => {
    setEmail(val);
    if (val) {
      setEmailError("");
    }
  };

  const validateFields = () => {
    if (!email) {
      setEmailError("Email is required.");
      return false;
    } else if (!validateEmail(email)) {
      setEmailError(errMsg.invalidEmail);
      return false;
    }
    return true;
  };

  // API_CALL: API call to request password reset and send OTP
  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    if (validateFields()) {
      setIsLoader(true);
      const { res, err } = await httpRequest<{
        message: string;
        otpExp: string;
      }>({
        method: "post",
        path: "/customer/request-password-reset",
        params: { email },
      });
      if (res) {
        const { message = "", otpExp = "" } = res;
        toast(message || "Success!", { type: "success" });
        // Store relevant information in Cookies
        let obj = {
          email: email,
          otpExpire: moment().add(2, "minutes").toISOString(),
          purpose: "forget",
        };
        sessionStorage.setItem(
          "doctorTwoFactor" as string,
          JSON.stringify(obj)
        );
        setEmail("");
        setEmailError("");
        navigate("/doctor/otp");
      } else {
        toast(err, { type: "error" });
      }
      setIsLoader(false);
    }
  };

  return (
    <div className="customer-login-main">
      <div className="container-1600">
        <div className="customer-login-main-inner">
          <div>
            <h1 className="font-Poppins-SemiBold font-size-32px theme-color-green leading-none text-center lg-main-head">
              Recovery Email
            </h1>
            <p className="font-size-16px theme-color-green font-Poppins-Regular">
              Enter your email and we send you a recovery code
            </p>
          </div>
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <div className="customer-login-main-inner-main">
              <div>
                <InputFeild
                  label="Email Address"
                  value={email}
                  onChange={handleChange}
                  id="email"
                />
                {emailError && (
                  <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                    {emailError}
                  </p>
                )}
              </div>
              <div className="login-btn-home-banner-parent flex items-center justify-center">
                <CircleButton
                  ButtonText={"Send"}
                  loader={isLoader}
                  type={"submit"}
                  btnExtralClasses={
                    "border border-[#00443f] hover:bg-[#fff]  hover:text-[#00443f]"
                  }
                  id="submit_btn"
                />
              </div>
            </div>
          </form>
          <p className="font-size-16px theme-color-green font-Poppins-Regular">
            Don't have an account?{" "}
            <Link
              to="/doctor/login"
              id="signInLink"
              className="font-Poppins-SemiBold underline hover:no-underline"
            >
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DoctorForgetPassword;
